var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgArrow1 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 18, height: 19, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M13.382 7.91a.562.562 0 1 0-.796-.796l-3.584 3.584-3.575-3.576a.563.563 0 0 0-.796.796l3.978 3.977a.563.563 0 0 0 .847-.06l3.926-3.925Z", fill: "#5F6671" }));
export { SvgArrow1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjM4MiA3LjkxYS41NjIuNTYyIDAgMSAwLS43OTYtLjc5NmwtMy41ODQgMy41ODQtMy41NzUtMy41NzZhLjU2My41NjMgMCAwIDAtLjc5Ni43OTZsMy45NzggMy45NzdhLjU2My41NjMgMCAwIDAgLjg0Ny0uMDZsMy45MjYtMy45MjVaIiBmaWxsPSIjNUY2NjcxIi8+PC9zdmc+";
